import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { LoginPage } from 'containers/LoginPage'
import ProtectedRoute from 'components/ProtectedRoute'
import { UserPage } from 'containers/UserPage'
import { ShopTimePage } from 'containers/ShopTimePage'
// import JowanContainer from 'containers/JowanPage'

const AppRoutesContainer = () => {
  return (
    <Switch>
      <Route exact path='/home'>
        HOME
      </Route>
      <Route exact path='/about'>
        ABOUT
      </Route>
      {/* <Route exact path='/for-jowan'>
        <JowanContainer />
      </Route> */}
      <Route exact path='/login'>
        <LoginPage />
      </Route>
      <ProtectedRoute exact path='/shop-time'>
        <ShopTimePage />
      </ProtectedRoute>
      <ProtectedRoute exact path='/user-info'>
        <UserPage />
      </ProtectedRoute>
      <Redirect from='/' to='/for-jowan' />
    </Switch>
  )
}

export default AppRoutesContainer
